entity = function (id, admin, cui_enabled) {

	var objEntity = {};
	var objDialog = dialog();
	var objEntityTypes = entityTypes(true);
	var objDom = dom(cui_enabled);
	var objHierarchy = hierarchy(cui_enabled);

	var apSelectParticipants = 0;
	var proposalSelectParticipants = 0;
	var APStepsWithRoles = '';
	var ProposalStepsWithRoles = '';
	var proposals = '';
	var childrenCount = 0;
	var apNames = '';
	var proposalNames = '';
	var replacements = '';
	var proposalReplacements = '';
	var apEditmodeOriginal = [];
	var apEditmodeEditing = [];

	var url = '';
	if (admin === undefined || admin === null) {
		url = '/admin/';
	} else if (admin) {
		url = '/admin/';
	} else if (!admin) {
		url = '/';
	}

	objEntity.updateEntity = function(id) {
		var hasErrors = false;
		$.validity.start();
		$('#entity-details-name').require();
		var result = $.validity.end();

		// Active/Inactive check
		var status = 'active';
		if (!($('#entity-details-status').is(':checked'))) {
			status = 'inactive';
		}

		// Perform insert here
		var postData = {
			name: $('#entity-details-name').val(),
			entityTypeID: $('#entity-details-type').val(),
			status:status
		};

		if (result.valid) {
			$.ajax({
				url: '/admin/entity:' + id,
				type: 'PUT',
				data: postData,
				beforeSend: function() {
					objDom.addMask('#entity-details-form');
				},
				success: function() {
					objDom.removeMask('#entity-details-form');
					//objEntity.entityList();
					$('#summary-entity-' + id).find('.summary-title').text(postData.name);
				}
			});
			// $(this).dialog('close');
		}

	};

	objEntity.createParentList = function(parents) {
		// Clean list out to reset it
		$('#entity-parents').contents().remove();

		console.log(parents);

		if (parents.length > 0) {
			$(parents).each(function(index, element) {
				console.log(element.name);

				//First, determine if this is a legitimate parent request
				var isValidParent = true;
				if ($('#entity-parents li input[value="'+element.id+'"]').length > 0) {
					//item already exists. Don't add it again!
					isValidParent = false;
				}

				if (isValidParent) {
					newParent = $('#parent-clone').clone().removeAttr('id');
					$(newParent).children('input').attr('name','parent[' + index  + ']').val(element.id);
					$(newParent).append(element.name);
					$('#entity-parents').append(newParent);
					$('#entity-available-parents option[value="' + element.id + '"]').attr('disabled', true);
				}
			});
		} else {
			$('#entity-parents').append('<li class="no-parents">You have not selected any parents.</li>');
		}

	};


	/*
	 * Function cleanEntityDialog
	 * Purpose: removes any previous entities from the dialog.
	 */
	objEntity.cleanEntityDialog = function() {

		$('#entity-dialog').removeClass('active');
		$('#entity-details-name').val('');
		$('#entity-details-type').val('');
		$('#entity-details-status').prop('checked',true);

		// Parents
		$('#entity-parents').contents().remove();
		$('#entity-parents').append('<li class="none">No parents selected</li>');
		$('#entity-parents-available option').removeAttr('disabled');

		// If no parents were available, remove the appended "No Entities Available" option
		if ($('#entity-parents-available option:first').val() === '') {
			$('#entity-parents-available option:first').remove();
		}

		// Roles
		$('#entity-roles').contents().remove();
		$('#entity-roles').append('<li class="none">No roles selected</li>');
		$('#entity-roles-available').removeAttr('disabled');
		$('#entity-roles-available option').removeAttr('disabled');
		// If no parents were available, remove the appended "No Role Types Available" option
		if ($('#entity-roles-available option:first').val() === '') {
			$('#entity-roles-available option:first').remove();
		}
	};

	objEntity.updateParents = function(parent, callback) {
		var id = +$('#entity-details-id').val();
		//console.log(parent)
		//Save Parent
		var parents = [];
		if ($('#entity-parents li input').length > 0) {
			$('#entity-parents li input').each(function(i) {
				parents[i] = +$(this).val();
			});
		}

		if (parent !== undefined && parent !== null) {
			parents.push(+parent);
		}

		// Perform insert here
		var postData = {
			id: id,
			parents: parents
		};

		$.ajax({
			url: '/admin/entity:' + id + '/saveParents.json',
			type: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify(postData),
			beforeSend: function() {
				//objDom.addMask('#entity-parents');
			},
			success: function(data) {
				callback && callback(data);
			}
		});

		//Disable this parent from the available parents in the dropdown
		objEntity.manageEntityParentsSelect();

	};

	objEntity.manageEntityParentsSelect = function() {

		var manageParentsForm = function (type) {
			if (type === 'disable'){
				$('#entity-parents-available').attr('disabled','disabled');
				$('.entity-parents-add').addClass('disabled');
			}
			if (type === 'enable'){

				$('#entity-parents-available').removeAttr('disabled');
				$('.entity-parents-add').removeClass('disabled');
				$('#entity-parents-available').val($('#entity-parents-available option:not(:disabled):first').val());
			}
		};

		var msg = '';
		// First, if coming from addParent, make sure all parents in the list are disabled in the dropdown
		if ($('#entity-parents li').length > 0) {
			$('#entity-parents li input[name^="parent"]').each(function() {
				var type = $(this).val();
				$('#entity-parents-available option').each(function() {
					if ($(this).val() === type) {
						$(this).attr('disabled',true);
					}
				});
			});
		}

		// If all entities are parents already OR there are NO eligible parents
		if ($('#entity-parents-available option').length > 0 &&
			$('#entity-parents-available option:disabled').length === $('#entity-parents-available option').length) {
			msg = 'No eligible parents';
			$('<option value="" selected="selected">' + msg + '</option>').insertBefore($('#entity-parents-available option:first'));
			manageParentsForm('disable');
		}

		// If the item has no parents assigned
		else if ($('#entity-parents li').length === 0) {
			$('#entity-parents').append('<li class="no-parents">No parents selected</li>');
			manageParentsForm('enable');
		}

		// Else, make sure to remove the no parents list item and enable the parents form
		else {
			//$('.no-parents').remove();
			$('#entity-parents-available option[value=""]').remove();
			manageParentsForm('enable');
		}
	};


	objEntity.viewEntityRoles = function(id) {
		$('#' + id).toggleClass('show-roles');
		objEntity.verticalStretch();
	};


	objEntity.importEntities = function(externalSystem, externalMapId, results) {
		// `results` is a JSON string. See issue #278
		var results = JSON.parse(results);

		var importSource = {
			'catalog': externalSystem,
			'catalogId': externalMapId
		};

		$.ajax({
			url: '/admin/entity/importHierarchy.json',
			type: 'PUT',
			data: {
				'hierarchy': JSON.stringify(results),
				'importSource': importSource,
				// FIXME: are we really always doing a dry-run? This variable
				// name is confusing.
				'dryRun': true
			},
			success: function(result) {
				var dialog;

				if (! $.isEmptyObject(result.data.relations) ) {
					dialog = objDialog.createBasicWarningDialog('overwrite-fields', function(dialog, defaults) {

						// Message
						$(dialog).append('<p>Some of the entities from ' + externalSystem + ' already exist in Curriculog.</p>');
						$(dialog).append('<p>You may continue the import and merge the entities or cancel the import.</p>');

						// Actions
						defaults.buttons = {
							'Continue and Merge': function() {
								objEntity.finalizeHierarchyImport(results, importSource);
								$(this).dialog('close');
							},
							Cancel : function(){
								$(this).dialog('close');
							}
						};

						defaults.close = function(event, ui) {
							$(this).remove();
						};
						$(dialog).dialog(defaults);
					});

				} else {

					dialog = objDialog.createBasicDialog('overwrite-fields', 'Finalize', function(dialog, defaults) {
						// Message
						$(dialog).append('<p>The hierarchy from ' + externalSystem + ' does not have any conflicts with your existing hierarchy.</p>');

						// Actions
						defaults.buttons = {
							'Finalize Import': function() {
								objEntity.finalizeHierarchyImport(results, importSource);
								$(this).dialog('close');
							},
							Cancel : function(){
								$(this).dialog('close');
							}
						};

						defaults.close = function(event, ui) {
							$(this).remove();
						};
						$(dialog).dialog(defaults);
					});
				}
			}
		});
	};

	objEntity.finalizeHierarchyImport = function(results, importSource) {
		$.ajax({
			url: '/admin/entity/importHierarchy.json',
			type: 'PUT',
			data: {
				'hierarchy': JSON.stringify(results),
				'importSource': importSource,
				'dryRun': false
			},
			success: function(result) {
				$('#growls').notify('create', 'saved-template', {
					title: 'Hierarchy Imported',
					text: 'The entities have been successfully imported.'
				});

				var entityTypeTabActive = $('#entity-types-tab').hasClass('active');
				location.reload();
			}
		});
	};

	objEntity.getChildren = function(obj) {
		var hasChildren = $(obj).closest('li').next().children('ul:not(.roles)');
		var children = [];
		var x = 0;
		if (hasChildren.length > 0) {
			$(hasChildren).children('li').each(function(){
				if ($(this).children('ul').length > 0) {
					//Item has children. Ignore those
				} else {
					children.push(this);
				}
			});

		}
		return children;
	};

	/**
	* This is passed a json entity object and recursively formats the entities including children as select drop down box options
	*/
	objEntity.formatEntityName = function(entity, level, selectId,  type, parent) {

		try {
			var escapedEntityName = escapeUserInput(entity.name);
			var output = '';

			for( i=0; i < level; i++){
				output += '&nbsp;&nbsp;&nbsp;';
			}
			output += escapedEntityName;

			// append option with appropriate non-breaking spaces to the select box
			switch(type) {
			case 'list':
				var parentClass = '';
				if (parent > 0) {
					parentClass = ' parent-'+parent;
				}
				$(selectId).append($('<li class="select-field"><button class="curriculog-add-widget value-'+ entity.id + parentClass +'" style="padding-left: '+ (level * 18) +'px">' + escapedEntityName + '</button></li>'));
				break;
			case 'select':
				$(selectId).append($('<option style="padding-left: '+ (level * 18) +'px"></option>').val(entity.id).html(escapedEntityName));
				break;
			default:
				$(selectId).append($('<option></option>').val(entity.id).html(output));
				break;
			}


			if (entity.children.length > 0) {
				level += 1;
				parent = entity.id;

				// if children loop through children and add to select
				$.each(entity.children, function(index3, entityChild) {
					objEntity.formatEntityName(entityChild, level, selectId, type, parent);
				});
			}
		} catch (err) {
			console.log(err);
		}
	};

	objEntity.entityParentsSelect = function(selectId, type, summary, callback) {

		if ($.isArray(selectId)) {
			selectId = selectId.join(', ');
		}

		if (type === undefined || type === null) {
			type = '';
		}

		var summary = (summary == 1) ? 1 : 0;

		return $.get('/entity.json', {includeInactive:0, summary:summary}, function(data) {
			$(selectId).contents().remove();
			var parent = 0;
			$.each(data.entities, function(index2, entity) {
				objEntity.formatEntityName(entity, 0, selectId, type, parent);
			});
			callback && callback();
		});
	};

	objEntity.verticalStretch = function() {
		var col1 = '#curriculog-hierarchy-column-content';
		var col2 = '#curriculog-types-column-content';
		domObject = dom();
		domObject.verticalStretchForm(col1, col2);
	};

	objEntity.destroy = function(obj, callback) {
		var dialog = objDialog.createBasicWarningDialog('delete-entity', function(dialog, defaults) {

			$(dialog).append('Are you sure you want to delete the <span class="strong">'+ obj.name + '</span> entity? ');

			defaults.buttons = {
				'Delete Entity': function() {
					$.ajax({
						url: '/admin/entity:' + obj.id + '/delete.json',
						type: 'DELETE',
						beforeSend: function() {
							objDom.addLoadingMask('#curriculog-hierarchy-column-content');
						},
						success: function(){
							objDom.removeMask('#curriculog-hierarchy-column-content');
							$('#curriculog-hierarchy-column-tabs .hierarchy-tab').trigger('click');
							callback && callback();
						}
					});

					$(this).dialog('close');
					$(this).remove();
				},
				Cancel: function() {
					$(this).dialog('close');
					$(this).remove();
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	objEntity.hasMultipleParents = function(obj, callback) {

		var itemId = ($(obj).closest('.entity').attr('class')).match(/entity-id-(\d*)/);
		var hasMultipleParents = ($('.'+itemId[0]).length > 1) ? true : false;

		if (hasMultipleParents) {
			var parent = ($(obj).closest('ul').closest('li').prev().children('.entity').attr('class')).match(/entity-id-(\d*)/);

			$('.'+itemId[0]).closest('li').addClass('curriculog-remove-warning-highlight');

			var dialog = objDialog.createBasicWarningDialog('multiple-parents', function(dialog, defaults) {
				// Message
				$(dialog).append('<span class="strong">'+ $(obj).closest('.entity').children('.entity-name').text() + '</span> has multiple parents. ');
				$(dialog).append('Would you like to delete this entity from the entire hierarchy, or just remove ');
				$(dialog).append('<span class="strong">' + $(obj).closest('.entity').children('.entity-name').text() + '</span>');
				$(dialog).append(' from '+ $('.'+parent[0]).children('.entity-name').text() +'?</p>');
				// Actions
				defaults.buttons = {
					'Delete Entity': function() {
						callback && callback();
						$(this).dialog('close');
					},
					'Remove Relationship': function() {
						var paramData = {
							parentId:parent[1]
						};
						$.ajax({
							url: '/admin/entity:' + itemId[1] + '/parent',
							type: 'DELETE',
							data: paramData,
							success: function(){
								objEntity.entityList();
							}
						});
						$(this).dialog('close');
						$(this).remove();
					},
					Cancel: function() {
						$(this).dialog('close');
						$(this).remove();
					}
				};
				// Cleanup
				defaults.close = function(event, ui) {
					$('.entity').closest('li').removeClass('curriculog-remove-warning-highlight');
				};
				$(dialog).dialog(defaults);

			});
		} else {
			callback && callback();
		}
	};

	return objEntity;
};
